import { formatText } from 'core/i18n';
import CheckBox from 'components/checkBox/checkBox';
import React, { useState } from 'react';
import { getFundsOriginsOptions } from 'components/FundsOriginDeclaration/getFundsOriginsOptions';
import { getFundsOriginsCheckedStatus } from 'components/FundsOriginDeclaration/getFundsOriginsCheckedStatus';

export const FundsOriginDeclaration = ({ userProfile, userProfileForm, formActions, handleSave }) => {
    const [fundsOriginsCheckedStatus, setFundsOriginsCheckedStatus] = useState(
        getFundsOriginsCheckedStatus(userProfile)
    );
    const handleDataToSave = (name, value) => {
        const newFundsOriginsCheckedStatus = { ...fundsOriginsCheckedStatus, [name]: value };
        setFundsOriginsCheckedStatus(newFundsOriginsCheckedStatus);
        handleSave('fundsOrigins', newFundsOriginsCheckedStatus);
    };
    const fundsOriginsOptions = getFundsOriginsOptions(handleDataToSave);

    return (
        <div className="col-sm-12 md-form-group">
            <label>{formatText('field-fundsOrigin')}</label>
            <label className="sub-label">{formatText('field-checkMoreThanOne')}</label>
            <CheckBox
                profileModel={'userProfile.is_fundsOrigin'}
                fieldsRequired="1"
                checkBoxList={fundsOriginsOptions}
                userProfile={userProfile}
                userProfileForm={userProfileForm}
                formActions={formActions}
                focusAnimated
                checkBoxListErrorMessage={formatText('validation-fieldRequired')}
            />
        </div>
    );
};
